<template>
    <div class="">
        <div class="custom-loader-wrapper" v-if="loader">
            <div class="text-center">
                <span class="d-block max-450">We are processing your download and this may take some time. Do not close this window until the download begins.</span>
                <img v-bind:src="$api_url+'/public/images/download-loader.svg'" class="loader-logo" width="100px"/>
                <p class="mt-5">Plesae click <a target="_blank" :href="$api_url+'/company/dashboard'">here</a> or below if you want to continue surfing the system.</p>
                <b-button  class="mb-1"  target="_blank"  :href="$api_url+'/company/dashboard'">Dashboard</b-button>
                            
            </div> 
        </div>
        <div class="row mt-4 no-margin">
            <div class="col-sm-4 mb-3 company-form-box-title row no-margin">
                <div class="col-sm-6 d-flex align-items-center text-right justify-content-end">Month</div>
                <div class="col-sm-6">
                    <b-form-select v-model="start_month">
                        <b-form-select-option v-for="(month, n) in months" :key="n" :value="month.value">{{month.text}}</b-form-select-option>
                    </b-form-select>
                </div>                 
            </div>
            <div class="col-sm-4 mb-3 company-form-box-title row no-margin">
                <div class="col-sm-6 d-flex align-items-center text-right justify-content-end">Year</div>
                <div class="col-sm-6">
                    <b-form-select v-model="start_year">
                        <b-form-select-option v-for="(year, n) in years" :key="n" :value="year">{{year}}</b-form-select-option>
                    </b-form-select>
                </div>                 
            </div>
            <div class="col-sm-4 mb-3 company-form-box-title row no-margin">
                    <button v-on:click="viewDetails()" class="btn btn-primary position-static mr-3">Preview Report</span></button>
                    <button v-on:click="getReport()" class="btn btn-primary position-static">Download</button>
            </div>
        </div> 
        <div class="col-sm-12 row mb-3 mt-3">
            <div class="d-inline-block trz_fields trz-custom-dropdown mb-1" >
                <b-dropdown id="dropdown-fields"  text="Select Additional Fields" ref="dropdown" class="mb-1 position-relative">
                    <b-dropdown-form>
                        <b-form-group @submit.stop.prevent>
                            <div class="form-group">
                                <b-form-checkbox-group
                                    v-model="column_selected"
                                    :options="column_options"                            
                                    switches 
                                    
                                />
                            </div>
                            <button type="button" @click="setcolumn()" class="btn btn-primary d-none">Save</button>
                        </b-form-group>
                    </b-dropdown-form>
                </b-dropdown>
            </div>
            <div class="d-inline-block ml-3 pt-2">{{show_selected}} {{clickSelect}}</div>
        </div>
        
        <b-modal id="bv-modal-PLMR" size="sm" hide-footer title="GF Loan Balance Report">
            <div>No Payslip found for selected Month</div>
        </b-modal>  
         
        
        <b-modal id="monthly-gf-loan-report" dialog-class="modal-xxl" size="xl" scrollable  hide-footer title="GF Loan Balance Report">
            <b-overlay  rounded="sm">
                <div class="clearfix row py-2 mb-2 border-bottom">       
                
                    <div class="col-md-6">                
                        <b-input-group class="mb-0 custom-search ml-auto mr-0">
                            <b-input-group-prepend is-text>
                                <b-icon icon="search"></b-icon>
                            </b-input-group-prepend>
                            <b-form-input type="search" placeholder="Search.." v-model="search" @input="resetPagination()"></b-form-input>
                        </b-input-group>
                    </div>        
                </div>
                
                <table class="table "> 
                    <thead class="" style="">
                        <tr class="table-head"  v-for="(detail, index) in paginatedData" :key="detail.employee_id">
                            <template v-if="index < 1">
                                <td class="text-center" v-for="(v,i,count) in detail"><template>{{ replaceTableHeads(i) }}</template></td>
                            </template>
                        </tr>
                    </thead>
                    <tbody>
                        <tr style="display: none;"></tr>
                        <tr class="table-row hover-bg " v-for="detail in paginatedData" :key="detail.employee_id">
                            <!--aboni 10-11-21-->
                            <template v-for="(v,i,count) in detail">
                                <td class="2" v-if="i == 'SN.' || i == 'employee_name' || i== 'Employee Code'  || i== 'employee_code'|| i== 'type' || i== 'repayment_tenure'   || i== 'department' || i== 'Department' || i== 'jobposition' || i== 'jobposition' || i== 'Jobposition' || i== 'employee_id' ||  column_selected.includes(i) ">{{v}} </td>
                                <td v-else   class="2 text-right" ><div v-if="v==0">--</div><div v-else>{{formatMoney(v)}}</div></td>

                            </template>
                            <!--aboni 10-11-21-->
                            
                            
                        </tr>
                    </tbody>
                </table>
                <div v-if="paginatedData.length == 0" class="px-3 py-3 no-result-cell text-center">
                    <span v-if='showoverlay==true' class="d-block text-center">{{empty_result}}</span>
                    <span v-if='showoverlay==false' class="d-block text-center">No Payslip found for selected Month</span>
                    <img v-if='showoverlay==true' v-bind:src="$api_url+'/public/images/download-loader.svg'" class="loader-logo" width="100px"/>
                    
                </div>
                <div v-else class="px-3"><b-pagination-nav  v-model="pagination.currentPage" :number-of-pages="pagination.pages" prev-text="Previous" next-text="Next" base-url="#" first-number last-number ></b-pagination-nav></div>
            </b-overlay>
        </b-modal>   
    </div>
</template>

<script>
    
    
    export default{
        
        mounted() {
            this.$refs.trzcalendar;
        },
        props: ['pageurl','flag'],   
        components: {
            
        },     
        data(){
            
            return {
                 
                pageUrl:this.$api_url,
                
                search:'',
                length: 20,
                pagination: {currentPage: 1, pages:1},

                empty_result : 'Please hold tight! We are preparing the report data for you!',
                start_year : '',
                currentYear: new Date().getFullYear(),
                currentMonth:new Date().getMonth(),
                start_month: '',
                start_month_name: '',
                loader: false,
                showoverlay : true,
                report_data:[],
                payroll_reporting_data : [],
                details : [],

                months: [
                    { value: "1", text: "January" },
                    { value: "2", text: "February" },
                    { value: "3", text: "March" },
                    { value: "4", text: "April" },
                    { value: "5", text: "May" },
                    { value: "6", text: "June" },
                    { value: "7", text: "July" },
                    { value: "8", text: "August" },
                    { value: "9", text: "September" },
                    { value: "10", text: "October" },
                    { value: "11", text: "November" },
                    { value: "12", text: "December" },
                ],
                /***Ali */

                column_selected:[],
                column_options:[],
                default_fields:[],
                column_selected_view:[],
                show_selected:'',

                
            }
        },
        methods:{
            
            validateState(ref)
            {
                if (
                    this.veeFields[ref] &&
                    (this.veeFields[ref].dirty || this.veeFields[ref].validated)
                ) {
                    return !this.veeErrors.has(ref);
                }
                return null;
            },
            getPayrollReporting: function()
            {
                if(!this.checkNet()) return false;
                axios.get(this.$api_url+'/report/payrollreporting' , {
                    params: {
                        
                    }
                }).then(function(response){
                    this.payroll_reporting_data = response.data;
                    //console.log(this.payroll_reporting_data);
                    
                }.bind(this));
            },
            getReport: function()
            {
                if(!this.checkNet()) return false;
                this.loader = true;
                let url = ''
               
                url = this.$api_url + '/gf/loan-monthly-report';
                


                // if(this.column_selected.indexOf('name') === -1){
                //     this.column_selected.unshift('name');
                // }

                let formData = new FormData();
                formData.append('year', this.start_year);
                formData.append('month', this.start_month);
                formData.append('grid_report', 'Excel');
                formData.append('report', 1);
                formData.append('column_selected', this.column_selected);
                
                
                let currentObj = this;
                axios.post(url, formData).then(function (response) 
                {
                    this.loader = false;
                    if(response.data.errors)
                    {
                        this.details = [];
                        this.$bvModal.show('bv-modal-PLMR');
                    } 
                    else
                    {
                        var fileURL = response.data;
                        this.download_file(fileURL);

                    }
   
                    
                }.bind(this))
                .catch(error => {
                    if(error.response){
                        this.$bvModal.show('bv-modal-PLMR');
                        this.loader = false;
                    }
                });
                return false;
            },
            download_file(fileURL) 
            {
                if(!this.checkNet()) return false;
                
                var fileName = fileURL.substring(fileURL.lastIndexOf('/')+1);
                if (!window.ActiveXObject) {
                    var save = document.createElement('a');
                    save.href = fileURL;
                    save.target = '_blank';
                    //var filename = fileURL.substring(fileURL.lastIndexOf('/')+1);
                    save.download = fileName || filename;
                    if ( navigator.userAgent.toLowerCase().match(/(ipad|iphone|safari)/) && navigator.userAgent.search("Chrome") < 0) {
                            document.location = save.href;
                        }else{
                            var evt = new MouseEvent('click', {
                                'view': window,
                                'bubbles': true,
                                'cancelable': false
                            });
                            save.dispatchEvent(evt);
                            (window.URL || window.webkitURL).revokeObjectURL(save.href);
                        }    
                }
                else if ( !! window.ActiveXObject && document.execCommand)     {
                    var _window = window.open(fileURL, '_blank');
                    _window.document.close();
                    _window.document.execCommand('SaveAs', true, fileName || fileURL)
                    _window.close();
                }
            },
            replaceTableHeads(val){
                val = val.replace(/_/g, ' ');
                
                val = val.toLowerCase().split(' ');
                for(var i = 0; i < val.length; i++){
                    val[i] = val[i].charAt(0).toUpperCase() + val[i].substring(1);     
                }
                return val.join(' ');
            },
            viewDetails: function()
            {
                this.details = [];
                this.showoverlay =true;
                if(!this.checkNet()) return false;
                
                var months = ["", "January", "February", "March", "April", "May", "June", 
           "July", "August", "September", "October", "November", "December" ];
           
                this.start_month_name = months[this.start_month];
                // if(this.column_selected.indexOf('name') === -1){
                //     this.column_selected.unshift('name');
                // }
                
                this.report_data = [];
                this.details = [];
                let formData = new FormData();
                formData.append('year', this.start_year);
                formData.append('month', this.start_month);
                formData.append('viewmode', 1);
                formData.append('grid_report', 'Excel');
                formData.append('report', 1);
                formData.append('column_selected', this.column_selected);
                let url = this.$api_url + '/gf/loan-monthly-report';
                
                
                let currentObj = this;
                axios.post(url, formData).then(function (response) 
                {

                    if(response.data.errors)
                    {
                         
                         this.$bvModal.show('bv-modal-PLMR');
                    } 
                    else
                    {
                        var list_data = response.data;
                        this.report_data = response.data;


                        if(this.details.length ==0)
                        {
                            this.showoverlay =false;
                        }
                        this.details = this.report_data.data;

                        console.log(this.details.length);


                    }
                    
                }.bind(this))
                .catch(error => {
                    if(error.response){
                        this.$bvModal.show('bv-modal-PLMR');
                        this.loader = false;
                    }
                });

                
                this.$bvModal.show('monthly-gf-loan-report');
                
                
            },
            formatMoney: function(amount)
            {
                var money = Number(amount);
                money = money.toLocaleString();
                if(money=='NaN')
                money = amount;
                else{
                if(money.indexOf(".")<0)
                money = money+".00";
                }
                return money;
            }, 
            
            getPayrollDefaultField()
            {
                if(!this.checkNet()) return false;
                axios.get(this.$api_url+'/report/payrollreporting/defaultfields' , {
                }).then(function(response){
                    this.default_fields = response.data;
                    let available_colunms = [];
                    
                    let co = [];
                    var txt = '';
                    this.default_fields.forEach(element => {
                        
                        if(element=='etin')
                        {
                            txt = 'e-TIN';
                        }
                        else if(element=='jobposition')
                        {
                            txt = 'Job Position';
                        }
                        else if(element=='nid')
                        {
                            txt = 'NID';
                        }
                        else if(element=='branch')
                        {
                            txt = 'Work Location';
                        }
                        else
                        {
                            txt = this.stringView(element);
                        }
                        co = co.concat([{ text: txt , value: element }]);
                        
                        

                        available_colunms = available_colunms.concat(element);
                    }); 

                    this.column_options = this.column_options.concat(co);
                    
                    
                    // console.log('available_colunms');

                    // console.log(available_colunms);

                    // console.log('column_selected');

                    // console.log(this.column_selected);

                    let final_column_selected = [];
                    this.column_selected.forEach(element => 
                    {
                        if(available_colunms.includes(element))
                        {
                            // console.log('available_colunms_element');
                            // console.log(element);
                            final_column_selected.push(element);
                        }
                        else
                        {
                            // console.log('available_colunms_missing');
                            // console.log(element);  
                            // //this.column_selected.splice(this.column_selected.lastIndexOf(element), 1);
                        }
                    }); 


                    // console.log('final_column_selected');
                    // console.log(final_column_selected);
                    
                    this.column_selected = final_column_selected;

                    // console.log('column_selected');
                    // console.log(this.column_selected);

                }.bind(this));
            },
            stringView(str) {
                var i, frags = str.split('_');
                for (i=0; i<frags.length; i++) {
                    frags[i] = frags[i].charAt(0).toUpperCase() + frags[i].slice(1);
                }
                return frags.join(' ');
            },
            setcolumn: function()
            {
                this.$cookies.set("report_column_selected", this.column_selected);
                
                this.$refs.dropdown.hide(true);
            },
            capitalizeTheFirstLetterOfEachWord(words) {
            var separateWord = words.toLowerCase().split(' ');
            for (var i = 0; i < separateWord.length; i++) {
                separateWord[i] = separateWord[i].charAt(0).toUpperCase() +
                separateWord[i].substring(1);
            }
            return separateWord.join(' ');
            }

        },
        created: function(){
            this.start_year = this.currentYear;
            this.start_month = this.currentMonth + 1;
            if(this.$cookies.isKey("report_column_selected"))
            {
                if(this.$cookies.get("report_column_selected") != null)
                    this.column_selected = this.$cookies.get("report_column_selected").split(',');
            } 
            this.getPayrollDefaultField();
            this.getPayrollReporting();
        },
        computed: 
        {
            years () {
                const year = new Date().getFullYear();
                return Array.from({length: year - 2018}, (value, index) => year - index)
            },
            filteredData() 
            {
                let filtered_list = [];

                filtered_list = this.details;
                
                
                if (this.search) 
                {
                    filtered_list = filtered_list.filter((row) => {return Object.keys(row).some((key) => {return String(row[key]).toLowerCase().indexOf(this.search.toLowerCase()) > -1;})});
                }                
                return filtered_list;
            },
            paginatedData() 
            {    
                
                return this.paginate(this.filteredData, this.length, this.pagination.currentPage);
            },
            clickSelect() 
            {    
                var lt = this.column_selected_view.length;
                
                this.column_selected_view = this.column_selected;
                if(this.column_selected_view.length !=  lt)
                {
                    this.column_selected_view = this.column_selected;
                }
                
                // if(this.column_selected.indexOf('name') > -1){
                //     this.column_selected.splice('name', 1);
                // }
                this.show_selected = this.column_selected_view.join();
                this.show_selected = this.show_selected.replaceAll("_", " ");
                this.show_selected = this.show_selected.replaceAll(",", " , ");
                this.show_selected = this.capitalizeTheFirstLetterOfEachWord(this.show_selected);
                
                if(this.column_selected.length ==0)
                {
                    this.show_selected = 'None Selected';
                }
                
                this.$cookies.set("report_column_selected", this.column_selected,'24h');

            },
        }
    }
</script>

<style>

.d-inline-block.trz_fields.trz-custom-dropdown.mb-1 button {
	position: relative !important;
	bottom: 0 !important;
}
/*
.trz_pr_y
{

}
*/

</style>